module.exports = __webpack_public_path__ + "img/about-desc-xs.1babf60d.png";